import { Component, Input } from '@angular/core';

@Component({
  selector: 'bidi-planning',
  templateUrl: './planning.component.html',
  styleUrls: ['./planning.component.scss']
})
export class PlanningComponent {
  @Input() planning;
  @Input() selected = false;
  showPreview = false;

  openPreview() {
    this.showPreview = true;
    console.log('open it!');
  }

  closePreview() {
    this.showPreview = false;
    console.log();
  }
}
